import React from 'react';
import SmartImage from './SmartImage';
import { resolveImageUrl as resolveImageUrlUtil } from '../utils/urlResolver';

/**
 * Artwork frame: blurred warm Artmosphere backdrop + full artwork visible (contain, no crop).
 */
export default function ArtworkFillDisplay({
  src,
  alt = 'Artwork',
  containerClassName = 'h-[min(52vh,480px)] w-full min-h-[240px]',
  imageClassName = '',
  onError,
  onExpandClick,
}) {
  const resolvedSrc = resolveImageUrlUtil(src) || src || '';
  const expandable = typeof onExpandClick === 'function';

  const handleKeyDown = (e) => {
    if (!expandable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onExpandClick(e);
    }
  };

  return (
    <div
      className={`relative overflow-hidden ${expandable ? 'cursor-zoom-in group/artwork' : ''} ${containerClassName}`}
      style={{
        background:
          'radial-gradient(circle at 20% 10%, rgba(255, 220, 160, 0.45), transparent 50%), radial-gradient(circle at 80% 90%, rgba(255, 186, 120, 0.35), transparent 55%), linear-gradient(145deg, #fff8ef 0%, #fdebd0 48%, #f5d0a8 100%)',
      }}
      role={expandable ? 'button' : undefined}
      tabIndex={expandable ? 0 : undefined}
      aria-label={expandable ? `Expand ${alt}` : undefined}
      onClick={expandable ? onExpandClick : undefined}
      onKeyDown={handleKeyDown}
    >
      {resolvedSrc ? (
        <img
          src={resolvedSrc}
          alt=""
          aria-hidden
          className="pointer-events-none absolute inset-0 h-full w-full scale-110 object-cover opacity-55 blur-2xl saturate-125"
        />
      ) : null}
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#fff8ef]/88 via-[#fdebd0]/72 to-[#f5d0a8]/78"
        aria-hidden
      />
      <SmartImage
        src={resolvedSrc}
        alt={alt}
        className={`relative z-[1] max-h-full max-w-full object-contain object-center ${imageClassName}`}
        containerClassName="relative z-[1] flex h-full w-full items-center justify-center p-2 sm:p-3 pointer-events-none"
        onError={onError}
      />
      {expandable && (
        <span className="pointer-events-none absolute left-3 top-3 z-[2] rounded-full border border-[#e8d4bc]/90 bg-white/90 px-2 py-0.5 text-[10px] font-medium text-[#8A7357] opacity-90 shadow-sm sm:opacity-0 sm:transition-opacity sm:group-hover/artwork:opacity-100">
          Tap to expand
        </span>
      )}
    </div>
  );
}
